import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminStore } from '@app/users/admin-service/admin-service.store';
import { UserDTO } from '@app/users/model/users-model';

interface WhitelistDTO {
  id: string;
  user: string;
  commercial: string;
  hostCode: string;
}

@Component({
  selector: 'app-whitelist',
  templateUrl: './whitelist-dialog.component.html',
  styleUrls: ['./whitelist-dialog.component.scss'],
})
export class WhitelistDialogComponent implements OnInit {
  public prescriptorsList: UserDTO[] = [];
  public searchForm: FormGroup;

  public userSelected: UserDTO;

  public isDisabledSearchButton: boolean = true;
  public isDisabledContinueButton: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<WhitelistDialogComponent>,
    private adminStore: AdminStore,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      search: ['', Validators.required],
    });

    this.searchForm.statusChanges.subscribe(() => (this.isDisabledSearchButton = this.searchForm.invalid));
  }

  onClickSearch() {
    this.userSelected = undefined;
    this.adminStore
      .getPrescriptorsChain(this.searchForm.controls.search?.value)
      .then((data) => (this.prescriptorsList = data));
    this.isDisabledContinueButton = false;
  }

  onClickSelect() {
    this.dialogRef.close({ user: this.userSelected });
  }
}
